const nav = document.querySelector("nav.header__inline-menu");
let inSubmenu = false;
let inSubsubmenu = false;

nav.querySelector("a").classList.add("focus");
nav.querySelector("a").focus();

nav.querySelectorAll("a").forEach((link, index)=>{
    link.addEventListener("keydown",(event,index)=>{
        if(event.key == "ArrowRight")
        {
            let focus = nav.querySelector(".focus");
            if(focus.closest("li").nextElementSibling && inSubmenu == false)
            {
                focus.classList.remove("focus");
                focus.closest("li").nextElementSibling.querySelector("a").classList.add("focus");
                focus.closest("li").nextElementSibling.querySelector("a").focus();
            }
            else if(inSubmenu == true)
            {
                if(focus.nextElementSibling)
                {
                    focus.classList.remove("focus");
                    focus.nextElementSibling.querySelector("a").classList.add("focus");
                    focus.nextElementSibling.querySelector("a").focus();
                    inSubsubmenu = true;
                }
                else
                {
                    if(focus.closest("li").nextElementSibling)
                    {
                        focus.classList.remove("focus");
                        focus.closest("li").nextElementSibling.querySelector("a").classList.add("focus");
                        focus.closest("li").nextElementSibling.querySelector("a").focus();
                    }
                }
            }
        }   
        else if(event.key == "ArrowLeft")
        {
            let focus = nav.querySelector(".focus");
            if(focus.closest("li").previousElementSibling && inSubmenu == false)
            {
                focus.classList.remove("focus");
                focus.closest("li").previousElementSibling.querySelector("a").classList.add("focus");
                focus.closest("li").previousElementSibling.querySelector("a").focus();
            }
            else if(inSubsubmenu == true)
            {
                focus.classList.remove("focus");
                focus.closest("ul").closest("li").querySelector("a").classList.add("focus");
                focus.closest("ul").closest("li").querySelector("a").focus();
                inSubsubmenu = false
            }
            else
            {
                if(focus.closest("li").previousElementSibling)
                {
                    focus.classList.remove("focus");
                    focus.closest("li").previousElementSibling.querySelector("a").classList.add("focus");
                    focus.closest("li").previousElementSibling.querySelector("a").focus();
                }
            }
            
        }
        else if(event.key == "ArrowDown")
        {
            event.preventDefault();

            let focus = nav.querySelector(".focus");
            if(focus.closest("li").classList.contains("list-menu--submenu"))
            {
                console.log("submenu");
                focus.classList.remove("focus");
                focus.closest("li").querySelector("ul").querySelector("li > a").classList.add("focus");
                focus.closest("li").querySelector("ul").querySelector("li > a").focus();
                inSubmenu = true;
            }
            else
            {
                if(focus.closest("li").nextElementSibling)
                {
                    focus.classList.remove("focus");
                    focus.closest("li").nextElementSibling.querySelector("a").classList.add("focus");
                    focus.closest("li").nextElementSibling.querySelector("a").focus();
                }
            }
        }
        else if(event.key == "ArrowUp")
        {
            event.preventDefault();
            let focus = nav.querySelector(".focus");
            if(focus.closest("li").previousElementSibling)
            {
                focus.classList.remove("focus");
                focus.closest("li").previousElementSibling.querySelector("a").classList.add("focus");
                focus.closest("li").previousElementSibling.querySelector("a").focus();
            }
            else
            {
                if(focus.closest(".list-menu-item").classList.contains("list-menu--submenu"))
                {
                    focus.classList.remove("focus");
                    focus.closest(".list-menu-item").querySelector("a").classList.add("focus");
                    focus.closest(".list-menu-item").querySelector("a").focus();
                    inSubmenu = false;
                }
            }
        }
    });
});

document.addEventListener("click",()=>{
    nav.querySelector(".focus").classList.remove("focus");
    inSubmenu = false;
    inSubsubmenu = false;
});

nav.addEventListener('focusin', (event) => {
    event.target.classList.add("focus");
});